import { Component, Input, Output, EventEmitter } from '@angular/core';
import { StyleManagerService, Theme } from 'app/s/style-manager/style-manager.service';

@Component({
  selector: 'app-theme-menu',
  templateUrl: './theme-menu.component.html',
  styleUrls: ['./theme-menu.component.scss']
})
export class ThemeMenuComponent {
  @Input() options: Array<Theme>;
  @Output() themeChange: EventEmitter<string> = new EventEmitter<string>();

  constructor(private styleManager: StyleManagerService) { }

  changeTheme(themeToSet: string) {
    this.themeChange.emit(themeToSet);
  }
}
